<div
  class="mt-1 padding-class"
  *ngIf="activatedRoute != 'project-report-setting/org-report-setting'"
  [ngClass]="{ 'disabled-checkbox': disableCheckbox }"
>
  <input
    type="checkbox"
    (change)="currentPack($event)"
    [checked]="params?.data?.isCurrentPack"
    class="chkOverview"
  />
</div>

<div
  class="padding-class-org-report"
  *ngIf="
    activatedRoute == 'project-report-setting/org-report-setting' &&
    !params.data?.isParent &&
    params.data
  "
>
  <input
    type="checkbox"
    (change)="updateReportSetting($event, params?.data)"
    [checked]="params?.data?.isAccess || params?.data?.selected"
    class="chkOverview"
  />
</div>
